import React from 'react';
import { compose, withStateHandlers } from 'recompose';
import styled, { StylesProps } from '../../../lib/styles';
import Typography from '../../../components/presentational/Typography';
import Button from '../../../components/presentational/Button';
import Spacer from '../../../components/presentational/Spacer';
import { callOnMount } from '../../../behaviour/patterns';
import sectionAcquisition from '../lib/sectionAcquisition';
import { getAccount } from '../../../lib/accountUtils';
import { Account } from '../../../models/user';
import { trackEvent } from '../../../lib/ga';
import { STICKY_ACQUISITION_CLICKED } from '../lib/ga';

import stickyAcquisitionStyles from './StickyAcquisition_styles';

export interface StickyAcquisitionProps {
  collapsed?: boolean;
  user?: Account | false;
  section?: string;
}

const StickyAcquisition = ({
  section = 'discover',
  styles,
}: StickyAcquisitionProps & StylesProps<typeof stickyAcquisitionStyles>) => {
  const acquisition =
    sectionAcquisition[section] || sectionAcquisition.discover;

  return (
    <div className={styles.container}>
      <Spacer
        row
        justify={'space-between'}
        selfV={'xxs'}
        selfH={'xs'}
        space={'xs'}
        className={styles.acquisition}
      >
        <div>
          <Typography color={'white'}>
            <strong>{acquisition.shortTitle}</strong>
          </Typography>

          <Typography color={'white'}>
            <small>{acquisition.shortDescription}</small>
          </Typography>
        </div>

        <Button
          color={'secondary'}
          href={'/membership'}
          onClick={() => {
            trackEvent(
              {
                ...STICKY_ACQUISITION_CLICKED,
                label: section,
              },
              { transport: 'beacon' }
            );
          }}
        >
          Sign&nbsp;up
        </Button>
      </Spacer>
    </div>
  );
};

export default compose(
  withStateHandlers(({}) => ({ user: undefined }), {
    loadUser: () => () => ({
      user: getAccount() || false,
    }),
  }),
  callOnMount('loadUser'),
  styled(stickyAcquisitionStyles)
)(StickyAcquisition);
